<template>
<div>
   <div class="iq-top-navbar" ref="topNavbar">
    <div class="iq-navbar-custom">
        <nav class="navbar navbar-expand-lg navbar-light p-0">
        <div class="iq-navbar-logo d-flex align-items-center justify-content-between">
            <i class="ri-menu-line wrapper-menu"></i>
            <router-link :to="{name: 'product.listproduct'}" class="header-logo">
                <img :src="logo" class="img-fluid rounded-normal" alt="logo">
            </router-link>
            <h5 class="logo-title ml-3">COUPLUS</h5>
        </div>
            <!-- 폰(768 밑)은 오른쪽 머리 묶음이 통째로 숨는다(d-none d-md-block) — 옛 확장 안내만 여기 한 줄로 -->
            <a v-if="loginNotice && loginNotice.key === 'oldExtension'" class="header-ref-link header-ref-link--wide is-alert d-md-none ml-auto" href="https://chrome.google.com/webstore/detail/couplus/fdfjeigdbhekohnmjbggdcjomicdcjbp?hl=ko&authuser=0" target="_blank"
                :title="loginNotice.headline + ' — ' + loginNotice.action">
                <span class="header-ref-icon">
                    <i class="ri-download-2-line"></i>
                </span>
                <span class="header-ref-label">확장 업데이트</span>
            </a>
            <a v-if="extBanner && !oldExtensionNotice" class="header-ref-link header-ref-link--wide is-alert ext-update-link d-md-none ml-auto" href="https://chrome.google.com/webstore/detail/couplus/fdfjeigdbhekohnmjbggdcjomicdcjbp?hl=ko&authuser=0" target="_blank"
                :title="'확장 ' + (extBanner.kind === 'must' ? '꼭 업데이트' : '새 판 있음') + ' — v' + extBanner.installed + ' → v' + extBanner.target">
                <span class="header-ref-icon">
                    <i class="ri-download-2-line"></i>
                </span>
                <span class="header-ref-label">확장 업데이트</span>
            </a>
            <!-- 사이드바에서 연 메뉴들의 탭 (고정 최대 3개 + 순환, 합쳐서 최대 5개) -->
            <div class="nav-tab-bar d-none d-md-flex">
                <div
                    v-for="tab in navTabs"
                    :key="tab.name"
                    class="nav-tab"
                    :class="{ 'nav-tab--active': tab.name === $route.name, 'nav-tab--pinned': tab.pinned }"
                    :title="tab.label"
                    @click="goTab(tab)"
                >
                    <button
                        type="button"
                        class="nav-tab__pin"
                        :title="tab.pinned ? '고정 해제' : '탭 고정'"
                        @click.stop="togglePin(tab)"
                    >
                        <i class="ri-pushpin-2-fill"></i>
                    </button>
                    <span class="nav-tab__label">{{ tab.label }}</span>
                    <button type="button" class="nav-tab__close" title="탭 닫기" @click.stop="closeTab(tab)">
                        <i class="ri-close-line"></i>
                    </button>
                </div>
                <span v-if="navTabHint" class="nav-tab-hint">{{ navTabHint }}</span>
            </div>
            <div class="d-flex justify-content-end align-items-center d-none d-md-block">
<!--                <b-navbar-toggle target="nav-collapse" class="navbar-toggler d-none d-md-block">-->
<!--                <i class="ri-menu-3-line d-none d-md-block"></i>-->
<!--                </b-navbar-toggle>-->
                <b-collapse id="nav-collapse" is-nav>
                    <ul class="navbar-nav ml-auto navbar-list align-items-center">
                        <!-- <li class="nav-item nav-icon dropdown" v-nav-toggle>
                            <a href="#" class="search-toggle dropdown-toggle btn border add-btn"
                                id="dropdownMenuButton02" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <img src="@/assets/images/small/flag-01.png" alt="img-flag"
                                    class="img-fluid image-flag mr-2">En
                            </a>
                            <div class="iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                <div class="card shadow-none m-0">
                                    <div class="card-body p-3">
                                        <a class="iq-sub-card" href="#"><img
                                                src="@/assets/images/small/flag-02.png" alt="img-flag"
                                                class="img-fluid mr-2">French</a>
                                        <a class="iq-sub-card" href="#"><img
                                                src="@/assets/images/small/flag-03.png" alt="img-flag"
                                                class="img-fluid mr-2">Spanish</a>
                                        <a class="iq-sub-card" href="#"><img
                                                src="@/assets/images/small/flag-04.png" alt="img-flag"
                                                class="img-fluid mr-2">Italian</a>
                                        <a class="iq-sub-card" href="#"><img
                                                src="@/assets/images/small/flag-05.png" alt="img-flag"
                                                class="img-fluid mr-2">German</a>
                                        <a class="iq-sub-card" href="#"><img
                                                src="@/assets/images/small/flag-06.png" alt="img-flag"
                                                class="img-fluid mr-2">Japanese</a>
                                    </div>
                                </div>
                            </div>
                        </li> -->

                        <!-- <li>
                            <a href="#" class="btn border add-btn shadow-none mx-2 d-none d-md-block"
                                v-b-modal.new-order data-target="#new-order"><i class="las la-plus mr-2"></i>New
                                Order</a>
                        </li> -->
                        <!-- <li class="nav-item nav-icon search-content" v-nav-toggle>
                            <a href="#" class="search-toggle rounded dropdown-toggle" id="dropdownSearch" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <i class="ri-search-line"></i>
                            </a>
                            <div class="iq-search-bar iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownSearch">
                                <form action="#" class="searchbox p-2">
                                    <div class="form-group mb-0 position-relative">
                                        <input type="text" class="text search-input font-size-12"
                                            placeholder="type here to search...">
                                        <a href="#" class="search-link"><i class="las la-search"></i></a>
                                    </div>
                                </form>
                            </div>
                        </li> -->
                        <!-- <li class="nav-item nav-icon dropdown" v-nav-toggle>
                            <a href="#" class="search-toggle dropdown-toggle" id="dropdownMenuButton2"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-mail">
                                    <path
                                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
                                    </path>
                                    <polyline points="22,6 12,13 2,6"></polyline>
                                </svg>
                                <span class="bg-primary"></span>
                            </a>
                            <div class="iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                <div class="card shadow-none m-0">
                                    <div class="card-body p-0 ">
                                        <div class="cust-title p-3">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <h5 class="mb-0">All Messages</h5>
                                                <a class="badge badge-primary badge-card" href="#">3</a>
                                            </div>
                                        </div>
                                        <div class="px-3 pt-0 pb-0 sub-card">
                                            <a href="#" class="iq-sub-card">
                                                <div class="media align-items-center cust-card py-3 border-bottom">
                                                    <div class="">
                                                        <img class="avatar-50 rounded-small"
                                                            src="@/assets/images/user/01.jpg" alt="01">
                                                    </div>
                                                    <div class="media-body ml-3">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <h6 class="mb-0">Emma Watson</h6>
                                                            <small class="text-dark"><b>12 : 47 pm</b></small>
                                                        </div>
                                                        <small class="mb-0">Lorem ipsum dolor sit amet</small>
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" class="iq-sub-card">
                                                <div class="media align-items-center cust-card py-3 border-bottom">
                                                    <div class="">
                                                        <img class="avatar-50 rounded-small"
                                                            src="@/assets/images/user/02.jpg" alt="02">
                                                    </div>
                                                    <div class="media-body ml-3">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <h6 class="mb-0">Ashlynn Franci</h6>
                                                            <small class="text-dark"><b>11 : 30 pm</b></small>
                                                        </div>
                                                        <small class="mb-0">Lorem ipsum dolor sit amet</small>
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" class="iq-sub-card">
                                                <div class="media align-items-center cust-card py-3">
                                                    <div class="">
                                                        <img class="avatar-50 rounded-small"
                                                            src="@/assets/images/user/03.jpg" alt="03">
                                                    </div>
                                                    <div class="media-body ml-3">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <h6 class="mb-0">Kianna Carder</h6>
                                                            <small class="text-dark"><b>11 : 21 pm</b></small>
                                                        </div>
                                                        <small class="mb-0">Lorem ipsum dolor sit amet</small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <a class="right-ic btn btn-primary btn-block position-relative p-2" href="#"
                                            role="button">
                                            View All
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li> -->
                        <!-- <li class="nav-item nav-icon dropdown" v-nav-toggle>
                            <a href="#" class="search-toggle dropdown-toggle" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-bell">
                                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                </svg>
                                <span class="bg-primary "></span>
                            </a>
                            <div class="iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <div class="card shadow-none m-0">
                                    <div class="card-body p-0 ">
                                        <div class="cust-title p-3">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <h5 class="mb-0">Notifications</h5>
                                                <a class="badge badge-primary badge-card" href="#">3</a>
                                            </div>
                                        </div>
                                        <div class="px-3 pt-0 pb-0 sub-card">
                                            <a href="#" class="iq-sub-card">
                                                <div class="media align-items-center cust-card py-3 border-bottom">
                                                    <div class="">
                                                        <img class="avatar-50 rounded-small"
                                                            src="@/assets/images/user/01.jpg" alt="01">
                                                    </div>
                                                    <div class="media-body ml-3">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <h6 class="mb-0">Emma Watson</h6>
                                                            <small class="text-dark"><b>12 : 47 pm</b></small>
                                                        </div>
                                                        <small class="mb-0">Lorem ipsum dolor sit amet</small>
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" class="iq-sub-card">
                                                <div class="media align-items-center cust-card py-3 border-bottom">
                                                    <div class="">
                                                        <img class="avatar-50 rounded-small"
                                                            src="@/assets/images/user/02.jpg" alt="02">
                                                    </div>
                                                    <div class="media-body ml-3">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <h6 class="mb-0">Ashlynn Franci</h6>
                                                            <small class="text-dark"><b>11 : 30 pm</b></small>
                                                        </div>
                                                        <small class="mb-0">Lorem ipsum dolor sit amet</small>
                                                    </div>
                                                </div>
                                            </a>
                                            <a href="#" class="iq-sub-card">
                                                <div class="media align-items-center cust-card py-3">
                                                    <div class="">
                                                        <img class="avatar-50 rounded-small"
                                                            src="@/assets/images/user/03.jpg" alt="03">
                                                    </div>
                                                    <div class="media-body ml-3">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <h6 class="mb-0">Kianna Carder</h6>
                                                            <small class="text-dark"><b>11 : 21 pm</b></small>
                                                        </div>
                                                        <small class="mb-0">Lorem ipsum dolor sit amet</small>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <a class="right-ic btn btn-primary btn-block position-relative p-2" href="#"
                                            role="button">
                                            View All
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li> -->
                        <!-- 참고 링크 그룹 : 필요할 때 찾는 것들이라 조용하게 -->
                        <li class="nav-item header-ref-item">
                            <a class="header-ref-link" href="https://sponge-sound-7be.notion.site/COUPLUS-4e097bd8dd084166aed6438fdacc1c89" target="_blank" title="쿠플러스 사용자 메뉴얼">
                                <i class="ri-book-open-line"></i>
                                <span>메뉴얼</span>
                            </a>
                        </li>
                        <li class="nav-item header-ref-item">
                            <a class="header-ref-link" href="https://chrome.google.com/webstore/detail/couplus/fdfjeigdbhekohnmjbggdcjomicdcjbp?hl=ko&authuser=0" target="_blank" title="크롬 확장 프로그램 설치">
                                <i class="ri-download-2-line"></i>
                                <span>확장</span>
                            </a>
                        </li>
                        <li class="nav-item header-ref-item">
                            <a class="header-ref-link" v-b-modal.channelTalk title="채널 문의">
                                <i class="ri-question-answer-line"></i>
                                <span>문의</span>
                            </a>
                            <b-modal id="channelTalk" ok-only title="채널문의" size="sm">
                                <div class="iq-search-bar device-search mb-0 mt-3 d-flex justify-content-center">
                                    <b-button variant="outline-warning" class="mb-1 mr-2 d-none d-md-block" href="http://pf.kakao.com/_AxcWvxj" target="_blank">
                                        쿠패스 문의 (구매, 배송대행 관련문의)
                                    </b-button>
                                    <b-button variant="outline-success" class="mb-1 mr-2 d-none d-md-block" href="http://pf.kakao.com/_xhDjxeb" target="_blank">
                                        쿠플러스 프로그램 문의
                                    </b-button>
                                </div>
                            </b-modal>
                        </li>
                        <li class="header-group-divider"></li>
                        <!-- 내 환경/설정 그룹 : 판단이 필요한 정보라 또렷하게 -->
                        <!--
                            쿠팡 로그인이 풀렸을 때만 나타난다. 예전에는 브라우저 툴바의 확장 아이콘에만
                            표시가 떠서, 아이콘을 고정해 두지 않은 셀러는 끊긴 줄도 몰랐다.
                            ⇒ 셀러가 실제로 보고 있는 이 화면에 띄운다. 창을 스스로 띄우지는 않는다 —
                               누르면 멀티계정관리 창이 열리고, 거기서 「확인」으로 다시 로그인한다.
                        -->
                        <!-- 안 쓴 무료 이용권(AI 로켓등록 권한 없는 사람만) — 로그인 유지로 들어와도 창·버튼이 뜬다 -->
                        <CouponOfferNav/>
                        <!-- 옛 확장(≤10.86) 안내는 업데이트할 곳(웹스토어 · 머리 «확장» 칸과 같은 주소)으로 — 멀티계정관리 창이 아니다(판 #460 ③) -->
                        <li v-if="loginNotice && loginNotice.key === 'oldExtension'" class="nav-item header-ref-item">
                            <a class="header-ref-link header-ref-link--wide is-alert" href="https://chrome.google.com/webstore/detail/couplus/fdfjeigdbhekohnmjbggdcjomicdcjbp?hl=ko&authuser=0" target="_blank"
                                :title="loginNotice.headline + ' — ' + loginNotice.action">
                                <span class="header-ref-icon">
                                    <i class="ri-download-2-line"></i>
                                </span>
                                <span class="header-ref-label">확장 업데이트</span>
                            </a>
                        </li>
                        <li v-else-if="loginNotice" class="nav-item header-ref-item">
                            <button type="button" class="header-ref-link header-ref-link--btn is-alert"
                                @click="$bvModal.show('coupangAccountModal')"
                                :title="loginNotice.headline">
                                <span class="header-ref-icon">
                                    <i class="ri-shield-user-line"></i>
                                </span>
                                <span>쿠팡 로그인</span>
                            </button>
                        </li>
                        <!-- 확장 새 판(판 #799 ⑥ · CLI 업데이트처럼 화면에) — 깔린 판 < 서버 최신이면 «새 판 있음», 하한 밑이면 «꼭 업데이트» -->
                        <li v-if="extBanner && !oldExtensionNotice" class="nav-item header-ref-item">
                            <a class="header-ref-link header-ref-link--wide is-alert ext-update-link" href="https://chrome.google.com/webstore/detail/couplus/fdfjeigdbhekohnmjbggdcjomicdcjbp?hl=ko&authuser=0" target="_blank"
                                :title="'확장 ' + (extBanner.kind === 'must' ? '꼭 업데이트' : '새 판 있음') + ' — v' + extBanner.installed + ' → v' + extBanner.target">
                                <span class="header-ref-icon">
                                    <i class="ri-download-2-line"></i>
                                </span>
                                <span class="header-ref-label">{{ extBanner.kind === 'must' ? '확장 꼭 업데이트' : '확장 새 판' }}</span>
                            </a>
                        </li>
                        <li class="nav-item header-ref-item">
                            <button type="button" class="header-ref-link header-ref-link--btn"
                                :class="{ 'is-alert': !cliConnected && !cliUpdating }"
                                @click="showCliGuide = true"
                                :title="cliUpdating ? 'CLI 업데이트 중' : (cliConnected ? ('CLI v' + cliVersion + ' 연결됨') : 'CLI 미연결 — 눌러서 연결하세요')">
                                <span class="header-ref-icon">
                                    <i class="ri-terminal-box-line"></i>
                                    <span v-if="cliUpdating" class="cli-spinner cli-spinner--dot"></span>
                                    <span v-else class="header-ref-dot" :class="{ connected: cliConnected }"></span>
                                </span>
                                <span>CLI</span>
                            </button>
                        </li>
                        <!-- 계정 — 누르면 바로 멀티계정관리 창(전환·추가·쿠팡 로그인·삭제·로그아웃). 드롭다운은 없앴다
                             (docs/multi-account-mcp-design.md §4 — 입력 창구는 멀티계정관리 창 하나) -->
                        <li class="nav-item header-ref-item caption-content">
                            <a href="#" class="header-ref-link header-ref-link--wide" id="dropdownMenuAccountSwitch"
                                title="계정 전환"
                                @click.prevent="$bvModal.show('coupangAccountModal')">
                                <span class="header-ref-icon">
                                    <i class="ri-user-shared-line"></i>
                                    <!-- 자동수집 일정이 하나라도 있으면 점. 설정은 멀티계정관리 창의 계정 줄 「자동수집」 -->
                                    <span v-if="autoCollectScheduled" class="header-ref-dot connected"
                                        title="자동수집 예약 있음"></span>
                                </span>
                                <span class="header-ref-label">{{ currentAccountLabel }}</span>
                            </a>
                            <!-- 자동수집 설정 창은 이 창 안에서 계정별로 연다(헤더 자동수집 아이콘은 없앴다) -->
                            <CoupangAccountModal
                                :switch-blocked-reason="switchBlockedReason"
                                @switch-account="switchAccount"
                                @logout="logout"
                                @auto-collect-status="updateAutoCollectStatus"
                                @auto-collect-change="refreshAutoCollectDot"
                            />
                        </li>
                        <li class="nav-item header-ref-item dropdown caption-content" v-nav-toggle>
                            <a href="#" class="header-ref-link dropdown-toggle" id="dropdownMenuButton4"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                title="계정관리">
                                <!-- <img src="@/assets/images/user/1.png" class="img-fluid rounded" alt="user"> -->

                                <!-- <p class="rounded-top img-fluid mb-1 ml-0">Company ID : Test</p> -->
                                <!-- <p class="rounded-top img-fluid mb-0 ml-0" v-if="showSellerInfo">Company ID : {{companyid}} &nbsp;</p> -->
                                <span class="header-ref-icon">
                                    <i class="ri-settings-3-line"></i>
                                </span>
                                <span>계정관리</span>
                            </a>
                            <div class="iq-sub-dropdown dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <div class="card shadow-none m-0">
                                    <div class="card-body p-0 text-center">
                                        <div class="media-body profile-detail text-center">
                                            <img src="@/assets/images/page-img/profile-bg.jpg" alt="profile-bg"
                                                class="rounded-top img-fluid mb-4">
                                        </div>
                                        <div class="p-3">
                                            <p class="mb-0" v-if="showSellerInfo">{{companyid}} / {{suppliercode}}</p>
                                            <h5 class="mb-1">{{email}}</h5>
                                            <p class="mb-0">{{accesshistory}}</p>
                                            <div class="d-flex align-items-center justify-content-center mt-3">
                                                <p class="btn border-secondary" style="height:200%;" @click="logout">로그아웃</p>
                                                <!-- <p><router-link :to="{name: 'people.suppliers'}" class="btn border-primary mr-2">예치금<br>10,000,000원</router-link></p> -->
                                                <p v-b-modal.editpayment class="btn border-primary ml-2" style="height:200%;">설정</p>

                                                    <b-modal id="editpayment" size="xl" title="설정" ok-only>
                                                            <!-- 판 #487 · 쿠팡 아이디·비번은 확장에만 저장(서버 받기 0) -->
                                                            <p class="text-muted small mb-2" data-test="coupang-pw-notice">쿠팡 비번은 서버로 보내지 않습니다</p>

                                                            <div class="card auth-card">
                                                                <div class="card-body p-0">
                                                                    <!-- <div class="d-flex align-items-center auth-content" v-if="$store.state.user.auth.showimport">
                                                                        <div class="col-lg-12 align-self-center">
                                                                            <div class="p-3">
                                                                                <h5 class="mb-2">자동수집설정</h5>
                                                                                <p>
                                                                                "Team Member"로 부계정을 추가해 주시고, "couplus01@gmail.com"으로 등록해 주세요.<br>
                                                                                등록후에 채널톡으로 문의해 주시면, 확인 후 아이디 생성 및 자동수집서버에 해당아이디를 세팅해 드립니다.<br>
                                                                                이후에는 매일 00시부터 순차적으로 SKU리스트와 판매현황이 자동수집됩니다.<br>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div> -->
                                                                    <div class="d-flex justify-content-start p-3">
                                                                        <div v-if="showpayment" class="p-3">
                                                                            <h5>현재 구독 결제 기준일 : 매월 {{ now }}일</h5>
                                                                            <p>{{ paymentcontent }}</p>
                                                                            <b-button  :variant="btnclass" class="mb-2 mt-2" @click="changepaymentstatus">{{ paymenttext }}</b-button>

                                                                        </div>
                                                                        <div v-else class="p-3">
                                                                            <h5>결제일(만료일) : {{ expireDate }}</h5>
                                                                            <p>현재 구독 설정이 되어 있지 않습니다. 다음 결제일부터 구독결제를 진행해 주세요</p>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        <div class="card auth-card" v-b-modal.changePassword>
                                                            <div class="card-body p-0">
                                                                <div class="d-flex justify-content-start p-3">
                                                                    <div class="p-3">
                                                                        <h5>비밀번호 변경 ></h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card auth-card" v-b-modal.geminiApi>
                                                            <div class="card-body p-0">
                                                                <div class="d-flex justify-content-start p-3">
                                                                    <div class="p-3">
                                                                        <h5>Gemini API 설정 ></h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card auth-card" v-b-modal.datalabAPI v-if="$store.state.user.auth.shownomad">
                                                            <div class="card-body p-0">
                                                                <div class="d-flex justify-content-start p-3">
                                                                    <div class="p-3">
                                                                        <h5>네이버 데이터랩 API 설정 ></h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-modal>
                                            </div>
                                            <b-modal id="changePassword" :title="forcePwChange ? '修改密码' : '비밀번호 변경'" hide-footer size="sm"
                                                :no-close-on-backdrop="forcePwChange" :no-close-on-esc="forcePwChange" :hide-header-close="forcePwChange">
                                                <b-form class="position-relative">
                                                    <b-form-group class="mb-0" label-for="newPassword">
                                                        <p v-if="forcePwChange" class="text-danger small mb-2">
                                                            首次登录(或密码已重置)，请先修改密码。新密码 8~20位，需包含英文+数字+特殊字符(!@#%^*+=-)。
                                                        </p>
                                                        <!-- 쿠패스 직원 첫 로그인(forcePwChange) 창은 중국어로 보여준다(YZY 요청 2026-10-03) -->
                                                        <p v-if="forcePwChange" class="text-muted small mb-2">
                                                            修改密码后，此账号在其他设备上的登录都会被退出。
                                                        </p>
                                                        <p v-else class="text-muted small mb-2">
                                                            비밀번호를 바꾸면 이 계정에 접속해 있던 다른 기기·다른 사람은 모두 로그아웃되고,
                                                            이 계정으로 걸려 있던 계정 전환 연결도 해제됩니다.
                                                        </p>
                                                        <b-form-input class="pw-input" :placeholder="forcePwChange ? '当前密码(初始密码)' : '현재 비밀번호 입력'" type="password" v-model="currentPassword" />
                                                        <b-form-input class="pw-input" :placeholder="forcePwChange ? '新密码' : '새로운 비밀번호 입력'" type="password" v-model="newPassword" />
                                                        <b-form-input class="pw-input" :placeholder="forcePwChange ? '再次输入新密码' : '새로운 비밀번호 확인'" type="password" v-model="checkNewPassword" />
                                                        <div class="change-button-area">
                                                            <b-button variant="outline-primary" class="change-button" @click="onClickPasswordChange">
                                                                {{ forcePwChange ? '确认修改' : '변경' }}
                                                            </b-button>
                                                        </div>
                                                    </b-form-group>
                                                </b-form>
                                            </b-modal>
                                            <b-modal id="geminiApi" title="Gemini API 설정" hide-footer size="sm">
                                                <b-form class="position-relative">
                                                    <b-form-group class="mb-0" label-for="gemini">
                                                        <h6><a class="text-primary" href="https://aistudio.google.com/app/apikey" target="_blank">Gemini API</a> Key를 입력해 주세요. </h6>
                                                        <b-form-input class="pw-input mt-2" placeholder="Gemini API Key 입력" type="text" v-model="geminiAPIKey" />
                                                        <b-button variant="outline-primary" class="change-button" @click="onClickGeminiAPIChange">적용</b-button>
                                                    </b-form-group>
                                                </b-form>
                                            </b-modal>
                                            <b-modal id="datalabAPI" size="xl" scrollable title="네이버 데이터랩 API설정" ok-only ok-title="닫기" class="detail-modal">
                                                <div>
                                                    <p><a href="https://developers.naver.com/apps/#/register=datalab" target="_blank"><u>네이버개발자센터</u></a>에 접속해서 아래의 순서로 API key를 받은 후 입력하고 API저장을 눌러주세요</p>
                                                    <card class="w-50 p-3">
                                                        <div class="alert mb-2" :class="datalabKeySaved ? 'alert-success' : 'alert-secondary'">{{ datalabKeySaved ? '네이버 데이터랩 열쇠가 저장돼 있습니다. 바꿀 때만 새 값을 넣고 API저장을 눌러 주세요.' : '저장된 네이버 데이터랩 열쇠가 없습니다.' }}</div>
                                                        <div class="d-flex justify-content-start align-items-center w-100">
                                                            <div class="w-25">Client ID : </div>
                                                            <div class="w-75">
                                                                <input type="text" class="form-control text-center" :placeholder="datalabKeySaved ? '저장됨 — 바꿀 때만 새로 넣기' : 'Client ID'" v-model="clientId" autocomplete="off">
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-content-start align-items-center w-100">
                                                            <div class="w-25">Client Secret : </div>
                                                            <div class="w-75">
                                                                <input type="password" class="form-control text-center" :placeholder="datalabKeySaved ? '저장됨 — 바꿀 때만 새로 넣기' : 'Client Secret'" v-model="clientSecret" autocomplete="new-password">
                                                            </div>
                                                        </div>
                                                        <b-button class="w-25 mt-3" variant="outline-success" @click="saveAPI">API저장</b-button>
                                                    </card>
                                                </div>
                                                <img  style="max-width:100%;" :src="require('../../../../assets/images/small/데이터랩api.png')">
                                            </b-modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </b-collapse>
            </div>
        </nav>
    </div>
</div>
<!-- <b-modal id="new-order" centered hide-footer hide-header hide-header-close>
    <div class="popup text-left">
        <h4 class="mb-3">New Order</h4>
        <div class="content create-workform bg-body">
            <div class="pb-3">
                <label class="mb-2">{{email}}</label>
                <input type="text" class="form-control" placeholder="Enter Name or Email">
            </div>
            <div class="col-lg-12 mt-4">
                <div class="d-flex flex-wrap align-items-ceter justify-content-center">
                    <div class="btn btn-primary mr-4" data-dismiss="modal" @click="$bvModal.hide('new-order')">Cancel</div>
                    <div class="btn btn-outline-primary" data-dismiss="modal" @click="$bvModal.hide('new-order')">Create</div>
                </div>
            </div>
        </div>
    </div>
</b-modal> -->
<div
    v-if="autoCollectMessage || accountSyncMessage"
    class="auto-collect-toast"
>
    <!-- 함께 전환 결과는 따로 둔다 — 새로고침 직후 수집 진행 알림이 덮어써 사라지지 않게 -->
    <div v-if="accountSyncMessage">{{ accountSyncMessage }}</div>
    <div v-if="autoCollectMessage">{{ autoCollectMessage }}</div>
</div>

<!-- 옛 CLI(1.2.x) 업데이트 안내 — 서버가 업체당 하루 한 번만 띄우라고 한다(/api/cli/old-notice). 「업데이트 방법」 = 아래 CLI 설치 가이드 창 -->
<div v-if="cliOldNotice" class="cli-old-notice" role="alert">
    <span>{{ cliOldNotice }}</span>
    <button type="button" class="cli-old-notice-link" @click="showCliGuide = true; cliOldNotice = ''">업데이트 방법</button>
    <button type="button" class="cli-old-notice-close" aria-label="닫기" @click="cliOldNotice = ''">&times;</button>
</div>

<!-- CLI 설치/사용 가이드 모달 -->
<div v-if="showCliGuide" class="cli-guide-overlay" @click.self="showCliGuide = false">
    <div class="cli-guide-modal">
        <div class="cli-guide-header">
            <span class="cli-guide-icon">{{ cliConnected ? '✅' : '⚠️' }}</span>
            <h5>couplus-cli {{ cliConnected ? '상태' : '설치 가이드' }}</h5>
            <button class="cli-guide-close" @click="showCliGuide = false">&times;</button>
        </div>
        <div class="cli-guide-body">
            <!-- 연결 상태 배너 -->
            <div v-if="cliConnected" class="cli-banner cli-banner-ok">
                <strong>연결됨</strong> — couplus-cli v{{ cliVersion }} 정상 동작 중
            </div>
            <div v-else class="cli-banner cli-banner-err">
                <strong>미연결</strong> — 아래 안내에 따라 설치해주세요
            </div>

            <!-- 업데이트 알림 -->
            <div v-if="cliUpdateAvailable" class="cli-banner cli-banner-update">
                <strong>업데이트 필요</strong> — v{{ cliVersion }} → v{{ cliLatestVersion }}
                <template v-if="cliNeedsReinstall">
                    <p style="margin:8px 0 4px;font-size:12px;">연결 프로그램을 한 번만 새로 설치해 주세요. 이후에는 자동으로 업데이트됩니다.</p>
                    <p style="margin:0 0 6px;font-size:12px;">{{ activeOsTab === 'mac' ? '터미널 앱을 연' : 'Windows키 + R → cmd 입력 → Enter' }} 후 아래 명령어를 순서대로 복사해 붙여넣고 Enter 를 눌러주세요.</p>
                    <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand(cliStopCommand, 'banner-stop')">
                        <code>{{ cliStopCommand }}</code>
                        <span class="copy-btn">{{ copiedCmdKey === 'banner-stop' ? '✅ 복사됨' : '📋 복사' }}</span>
                    </div>
                    <div class="cli-guide-cmd" @click="copyCommand(cliReinstallCommand, 'banner-reinstall')">
                        <code>{{ cliReinstallCommand }}</code>
                        <span class="copy-btn">{{ copiedCmdKey === 'banner-reinstall' ? '✅ 복사됨' : '📋 복사' }}</span>
                    </div>
                </template>
                <template v-else-if="cliUpdateNeedsManual">
                    <p style="margin:8px 0 4px;font-size:12px;">자동 업데이트가 끝나지 않았습니다. Codex·Claude 같은 AI 프로그램을 모두 끈 뒤, 터미널에서 couplus-cli update 를 실행해 주세요. (Mac 은 sudo couplus-cli update)</p>
                    <div class="cli-guide-cmd" @click="copyCommand(cliUpdateCommand, 'banner-update')">
                        <code>{{ cliUpdateCommand }}</code>
                        <span class="copy-btn">{{ copiedCmdKey === 'banner-update' ? '✅ 복사됨' : '📋 복사' }}</span>
                    </div>
                </template>
                <p v-else-if="cliUpdateWaitReasons.length" style="margin:8px 0 4px;font-size:12px;">지금 작업 중이라 미뤘습니다({{ cliUpdateWaitReasons.join(' · ') }}) — 끝나면 자동으로 업데이트됩니다.</p>
                <p v-else style="margin:8px 0 4px;font-size:12px;">버튼을 누르면 자동으로 최신 버전을 설치하고 재시작합니다.</p>
                <button v-if="!cliUpdateNeedsManual && !cliNeedsReinstall" class="cli-guide-btn cli-guide-btn-blue" style="margin-top:4px;"
                        :disabled="cliUpdating" @click="triggerCliUpdate">
                    {{ cliUpdating ? '업데이트 중…' : '지금 업데이트' }}
                </button>
            </div>

            <p class="cli-guide-desc">쿠팡 데이터 수집을 위해 <strong>couplus-cli</strong>를 설치해주세요.<br>최초 1회만 설치하면 이후 자동으로 실행됩니다.</p>

            <!-- OS 탭 -->
            <div class="cli-os-tabs">
                <button :class="{ active: activeOsTab === 'windows' }" @click="activeOsTab = 'windows'">Windows</button>
                <button :class="{ active: activeOsTab === 'mac' }" @click="activeOsTab = 'mac'">Mac</button>
            </div>

            <!-- Windows 가이드 -->
            <div v-if="activeOsTab === 'windows'">
                <!-- 신규 설치 -->
                <h6 class="cli-section-title">신규 설치</h6>
                <div class="cli-guide-step">
                    <div class="step-number">1</div>
                    <div class="step-content">
                        <h6>Node.js 설치</h6>
                        <p>아래 버튼을 클릭하여 Node.js를 설치해주세요. (이미 설치했다면 건너뛰세요)</p>
                        <a href="https://nodejs.org/dist/v22.15.0/node-v22.15.0-x64.msi" class="cli-guide-btn cli-guide-btn-green" target="_blank">
                            Node.js 다운로드 (Windows)
                        </a>
                        <p class="step-hint">다운로드된 파일을 실행하고 "Next"만 계속 눌러주세요.</p>
                    </div>
                </div>
                <div class="cli-guide-step">
                    <div class="step-number">2</div>
                    <div class="step-content">
                        <h6>couplus-cli 설치</h6>
                        <p><strong>Windows키 + R</strong> → <strong>cmd</strong> 입력 → Enter 후, 아래 명령어를 <strong>복사 → 붙여넣기 → Enter</strong></p>
                        <div class="cli-guide-cmd" @click="copyCommand('npm install -g https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz', 'win-new-install')">
                            <code>npm install -g https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz</code>
                            <span class="copy-btn">{{ copiedCmdKey === 'win-new-install' ? '✅ 복사됨' : '📋 복사' }}</span>
                        </div>
                        <p class="step-hint">"added" 메시지가 나오면 설치 완료! 자동으로 실행됩니다.</p>
                    </div>
                </div>
                <div class="cli-guide-step">
                    <div class="step-number">3</div>
                    <div class="step-content">
                        <h6>확인</h6>
                        <p>같은 터미널에서 아래 명령어로 정상 동작을 확인해주세요.</p>
                        <div class="cli-guide-cmd" @click="copyCommand('couplus-cli status', 'win-new-status')">
                            <code>couplus-cli status</code>
                            <span class="copy-btn">{{ copiedCmdKey === 'win-new-status' ? '✅ 복사됨' : '📋 복사' }}</span>
                        </div>
                        <p class="step-hint">"실행 중 (v1.2.x)" 메시지가 나오면 정상입니다.</p>
                        <button class="cli-guide-btn cli-guide-btn-blue" style="margin-top:8px;" @click="reloadPage">페이지 새로고침</button>
                    </div>
                </div>

                <!-- 업데이트 -->
                <h6 class="cli-section-title" style="margin-top:24px;">기존 사용자 업데이트</h6>
                <p style="font-size:13px;color:#666;margin-bottom:12px;"><strong>Windows키 + R</strong> → <strong>cmd</strong> 입력 → Enter 후 아래 명령어를 순서대로 실행해주세요.</p>
                <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand('couplus-cli stop', 'win-update-stop')">
                    <code>couplus-cli stop</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'win-update-stop' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand('npm install -g https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz', 'win-update-install')">
                    <code>npm install -g https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'win-update-install' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <div class="cli-guide-cmd" @click="copyCommand('couplus-cli status', 'win-update-status')">
                    <code>couplus-cli status</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'win-update-status' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <p class="step-hint" style="margin-top:6px;">"실행 중 (v{{ cliLatestVersion || '1.2.x' }})" 메시지가 나오면 정상입니다.</p>

                <!-- 업데이트가 안 될 때 -->
                <h6 class="cli-section-title" style="margin-top:24px;">업데이트가 잘 안 될 때</h6>
                <p style="font-size:13px;color:#666;margin-bottom:12px;">설치 중 오류가 나면 실행 중인 프로그램이 파일을 잡고 있는 경우가 많습니다. 아래 명령어를 순서대로 실행해주세요.</p>
                <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand('taskkill /F /IM node.exe', 'win-retry-kill')">
                    <code>taskkill /F /IM node.exe</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'win-retry-kill' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand('npm install -g --prefer-online https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz', 'win-retry-install')">
                    <code>npm install -g --prefer-online https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'win-retry-install' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <div class="cli-guide-cmd" @click="copyCommand('couplus-cli status', 'win-retry-status')">
                    <code>couplus-cli status</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'win-retry-status' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <p class="step-hint" style="margin-top:6px;">"실행 중 (v{{ cliLatestVersion || '1.2.x' }})" 메시지가 나오면 정상입니다.</p>
            </div>

            <!-- Mac 가이드 -->
            <div v-if="activeOsTab === 'mac'">
                <!-- 신규 설치 -->
                <h6 class="cli-section-title">신규 설치</h6>
                <div class="cli-guide-step">
                    <div class="step-number">1</div>
                    <div class="step-content">
                        <h6>Node.js 설치</h6>
                        <p>아래 버튼을 클릭하여 Node.js (LTS)를 설치해주세요. (이미 설치했다면 건너뛰세요)</p>
                        <a href="https://nodejs.org/dist/v22.15.0/node-v22.15.0.pkg" class="cli-guide-btn cli-guide-btn-green" target="_blank">
                            Node.js 다운로드 (Mac)
                        </a>
                        <p class="step-hint">설치 후 터미널에서 <code style="color:#e06c75;font-size:12px;">node -v</code> 로 버전을 확인해주세요.</p>
                    </div>
                </div>
                <div class="cli-guide-step">
                    <div class="step-number">2</div>
                    <div class="step-content">
                        <h6>couplus-cli 설치</h6>
                        <p><strong>터미널</strong> 앱을 열고 (Spotlight에서 "터미널" 검색), 아래 명령어를 실행해주세요.</p>
                        <div class="cli-guide-cmd" @click="copyCommand('sudo npm install -g https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz', 'mac-new-install')">
                            <code>sudo npm install -g https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz</code>
                            <span class="copy-btn">{{ copiedCmdKey === 'mac-new-install' ? '✅ 복사됨' : '📋 복사' }}</span>
                        </div>
                        <p class="step-hint">Mac 비밀번호를 입력하면 설치가 진행됩니다.</p>
                    </div>
                </div>
                <div class="cli-guide-step">
                    <div class="step-number">3</div>
                    <div class="step-content">
                        <h6>실행 및 확인</h6>
                        <p>같은 터미널에서 아래 명령어를 순서대로 실행해주세요.</p>
                        <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand('couplus-cli start', 'mac-new-start')">
                            <code>couplus-cli start</code>
                            <span class="copy-btn">{{ copiedCmdKey === 'mac-new-start' ? '✅ 복사됨' : '📋 복사' }}</span>
                        </div>
                        <div class="cli-guide-cmd" @click="copyCommand('couplus-cli status', 'mac-new-status')">
                            <code>couplus-cli status</code>
                            <span class="copy-btn">{{ copiedCmdKey === 'mac-new-status' ? '✅ 복사됨' : '📋 복사' }}</span>
                        </div>
                        <p class="step-hint">"실행 중 (v1.2.x)" 메시지가 나오면 정상입니다.</p>
                        <button class="cli-guide-btn cli-guide-btn-blue" style="margin-top:8px;" @click="reloadPage">페이지 새로고침</button>
                    </div>
                </div>

                <!-- 업데이트 -->
                <h6 class="cli-section-title" style="margin-top:24px;">기존 사용자 업데이트</h6>
                <p style="font-size:13px;color:#666;margin-bottom:12px;">터미널에서 아래 명령어를 순서대로 실행해주세요.</p>
                <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand('sudo couplus-cli stop', 'mac-update-stop')">
                    <code>sudo couplus-cli stop</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'mac-update-stop' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand('sudo npm install -g https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz', 'mac-update-install')">
                    <code>sudo npm install -g https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'mac-update-install' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <div class="cli-guide-cmd" @click="copyCommand('couplus-cli status', 'mac-update-status')">
                    <code>couplus-cli status</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'mac-update-status' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <p class="step-hint" style="margin-top:6px;">"실행 중 (v{{ cliLatestVersion || '1.2.x' }})" 메시지가 나오면 정상입니다.</p>

                <!-- 업데이트가 안 될 때 -->
                <h6 class="cli-section-title" style="margin-top:24px;">업데이트가 잘 안 될 때</h6>
                <p style="font-size:13px;color:#666;margin-bottom:12px;">설치 중 오류가 나면 실행 중인 프로그램이 파일을 잡고 있는 경우가 많습니다. 터미널에서 아래 명령어를 순서대로 실행해주세요.</p>
                <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand('killall node', 'mac-retry-kill')">
                    <code>killall node</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'mac-retry-kill' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <div class="cli-guide-cmd" style="margin-bottom:6px;" @click="copyCommand('sudo npm install -g --prefer-online https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz', 'mac-retry-install')">
                    <code>sudo npm install -g --prefer-online https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'mac-retry-install' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <div class="cli-guide-cmd" @click="copyCommand('couplus-cli status', 'mac-retry-status')">
                    <code>couplus-cli status</code>
                    <span class="copy-btn">{{ copiedCmdKey === 'mac-retry-status' ? '✅ 복사됨' : '📋 복사' }}</span>
                </div>
                <p class="step-hint" style="margin-top:6px;">"실행 중 (v{{ cliLatestVersion || '1.2.x' }})" 메시지가 나오면 정상입니다.</p>
            </div>
        </div>
    </div>
</div>

</div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { askExtension, accountSyncNotice, loadAccountSync, makeSwitchConfirm, syncCoupangAccount } from '@/services/coupangAccountFlow'
import CoupangAccountModal from '@/components/common/CoupangAccountModal.vue'
import CouponOfferNav from '@/components/common/CouponOfferNav.vue'
import ledgerCache from '@/services/ledgerCache'
import { cliDaemonUrl, CLI_DAEMON_ENABLED } from '@/config/cliDaemon'
import { tabBusyReasons, cliUpdateMode, extUpdateBanner } from '@/utils/autoUpdate'
import storeSnapshot from '@/services/storeSnapshot'
import { isCoupassTabRoute } from '@/views/backend/Logis/coupassMenu'

/*
    쿠팡 로그인이 풀렸는지 **얼마나 자주 확인할지.**

    확인 한 번이 쿠팡에 나가는 요청 한 번이다. 그래서 배경에서 돌리지 않고 **이 화면이
    열려 있고 보이는 동안만** 확인한다 — 안내는 셀러가 볼 때 정확하면 되고, 그때가 고칠 수
    있는 유일한 때다.

    10분으로 잡은 근거: 끊긴 것을 늦어도 10분 안에 알게 되고(그 사이 도구를 부르면 그쪽이
    먼저 알려준다), 화면을 하루 8시간 켜 두는 셀러도 48번이다 — 화면을 쓰는 동안 쿠팡에
    나가는 정상 트래픽에 비하면 없는 수준이다. 더 짧게 잡을 이유가 없다.
*/
const LOGIN_NOTICE_POLL_MS = 10 * 60 * 1000
// 탭을 왔다 갔다 할 때마다 확인하지 않는다. 2분 안에 이미 물었으면 그 답을 쓴다.
const LOGIN_NOTICE_MIN_GAP_MS = 2 * 60 * 1000

// 1.3.4 이하 배포본은 빌드 버그로 /self-update 가 요청 없이 끝난다 — 수동 재설치만 된다(1.3.5 부터 고쳐짐)
const CLI_LAST_BROKEN_SELF_UPDATE = '1.3.4'
// 이 버전 미만 = 옛 CLI(1.2.x) — 업데이트 안내를 서버에 묻는다(서버 tool-exec/cli-old-notice.js OLD_BELOW 와 같은 값)
const CLI_OLD_BELOW = '1.3.0'
// 1.3.14 이하는 AI 프로그램(Codex·Claude)이 켜져 있으면 백그라운드 자동 업데이트가 조용히 실패한다.
// 데몬(/health)은 버전만 알려 주므로, 같은 「현재→최신」 차이가 이만큼 이어지면 실패로 보고 수동 안내를 띄운다.
// 데몬은 기동 직후 업데이트를 시도하므로 정상이면 몇 분 안에 버전이 바뀐다.
const CLI_UPDATE_STUCK_MS = 30 * 60 * 1000
const CLI_UPDATE_PENDING_KEY = 'couplusCliUpdatePending'
// 계정 전환은 새로고침으로 끝난다 — 쿠팡 계정을 맞춘 결과 알림을 새로고침 뒤에 띄우려고 잠깐 담아 둔다
const ACCOUNT_SYNC_NOTICE_KEY = 'couplusAccountSyncNotice'
// 'x.y.z' 숫자 비교. a<b → -1, 같으면 0, a>b → 1. 비교할 수 없으면 null
function compareCliVersion(a, b) {
    const parse = v => {
        const m = /^v?(\d+)\.(\d+)\.(\d+)$/.exec(String(v == null ? '' : v).trim())
        return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null
    }
    const pa = parse(a)
    const pb = parse(b)
    if (!pa || !pb) return null
    for (let i = 0; i < 3; i++) {
        if (pa[i] !== pb[i]) return pa[i] < pb[i] ? -1 : 1
    }
    return 0
}

export default {
    name:"HeaderStyle1",
    components: {
        CoupangAccountModal,
        CouponOfferNav
    },
    computed : {
        // 네이버 데이터랩 열쇠 «저장됨» — 서버가 주는 표지만 본다(열쇠 값은 화면에 없다 · cpl-x3-naverkeyaes-1)
        datalabKeySaved() {
            return !!this.$store.state.settings?.[0]?.hasDatalabKey;
        },
        busyReasonsKey() {
            return tabBusyReasons(this.$store.state).join('|');
        },
        oldExtensionNotice() {
            return !!(this.loginNotice && this.loginNotice.key === 'oldExtension');
        },
        // 확장 업데이트 띠(판 #799 ⑥) — 깔린 판(CLI /health.extVersion) · 최신·하한(서버) 중 하나라도 모르면 띠 0
        extBanner() {
            return extUpdateBanner({ installed: this.extInstalledVersion, latest: this.extLatest.latest, min: this.extLatest.min });
        },
        // 자동 업데이트가 안 되는 CLI(1.3.4 이하)면 「지금 업데이트」 대신 재설치 안내. 비교 불가 값이면 기존 동작
        cliNeedsReinstall() {
            if (!this.cliUpdateAvailable) return false;
            const cmp = compareCliVersion(this.cliVersion, CLI_LAST_BROKEN_SELF_UPDATE);
            return cmp !== null && cmp <= 0;
        },
        // 기존 「기존 사용자 업데이트」 안내와 같은 명령 — 설치 전에 실행 중인 CLI 를 먼저 멈춘다
        cliStopCommand() {
            return this.activeOsTab === 'mac' ? 'sudo couplus-cli stop' : 'couplus-cli stop';
        },
        // 자동 업데이트 실패(버튼으로 시도했거나, 오래 버전이 그대로) → 수동 업데이트 안내
        cliUpdateNeedsManual() {
            return this.cliUpdateFailed || this.cliUpdateStuck;
        },
        cliUpdateCommand() {
            return this.activeOsTab === 'mac' ? 'sudo couplus-cli update' : 'couplus-cli update';
        },
        cliReinstallCommand() {
            const cmd = 'npm install -g https://www.couplus.co.kr/downloads/couplus-cli-latest.tgz';
            return this.activeOsTab === 'mac' ? 'sudo ' + cmd : cmd;
        },
        // 전환 버튼에 지금 계정을 띄운다 — 뭘 보고 있는지가 헤더에서 바로 보여야 한다
        currentAccountLabel() {
            return this.$store.state.user?.companyid || this.$store.state.user?.email || '계정';
        },
        // 전환하면 안 되는 상황이면 그 이유. 빈 문자열이면 전환해도 된다
        switchBlockedReason() {
            if (this.$store.state.collectingItems.length) {
                return '수집이 진행 중입니다. 끝난 뒤에 전환할 수 있습니다.';
            }
            if (this.$store.state.pendingLedgerWrites > 0) {
                return '저장 중입니다. 잠시 후 다시 시도해 주세요.';
            }
            return '';
        },
        ...mapGetters({
            companyid: 'companyid',
            suppliercode: 'suppliercode',
            appName: 'appName',
            logo:'logo',
            accesshistory: 'accesshistory',
            email:'email',
            image1:'image1',
            expireDate: 'expireDate'
        }),
        navTabs() {
            // 쿠패스 메뉴는 쿠패스 탭 바가 맡는다 — 예전에 저장된 쿠패스 헤더 탭(子账号管理·客服助手)은 감춘다
            return this.$store.state.navTabs.tabs.filter(t => !isCoupassTabRoute(t.name));
        },
    },
    data(){
		return{
            showSellerInfo:true,
            now:'',
            paymenttext:'',
            paymentcontent:'',
            btnclass:'',
            showpayment:true,
            currentPassword: '',
            newPassword: '',
            checkNewPassword: '',
            forcePwChange: false,   // 임시 비밀번호(mustChangePw) 계정 — 바꾸기 전까지 변경 창을 못 닫는다
            geminiAPIKey:'',
            clientId: '',   // 데이터랩 열쇠는 화면이 들지 않는다 — 새로 넣을 때만 채움(저장됨 여부는 settings.hasDatalabKey · cpl-x3-naverkeyaes-1)
			clientSecret: '',
            messageEventHandler: null,
            autoCollectMessage: '',
            autoCollectMessageTimer: null,
            accountSyncMessage: '',        // 쿠플러스·쿠팡 계정 함께 전환 결과 한 줄
            accountSyncMessageTimer: null,
            autoCollectScheduled: false,   // 어느 계정이든 자동수집 일정이 있나(계정 버튼 점)
            // 계정 전환 (목록·추가·해제는 멀티계정관리 창 CoupangAccountModal 이 한다)
            switching: false,
            showCliGuide: false,
            copiedCmdKey: '',
            copiedCmdTimer: null,
            cliConnected: false,
            cliVersion: null,
            cliLatestVersion: null,
            cliUpdateAvailable: false,
            cliUpdating: false,
            cliUpdateFailed: false,
            cliUpdateStuck: false,
            cliUpdatePrompted: false,
            cliBusy: null,               // CLI /health.busy — 바쁨 문(판 #308) · 옛 CLI 는 없음
            cliUpdateWaitReasons: [],    // 바빠서 업데이트를 미룬 까닭(창 안 안내)
            extInstalledVersion: null,   // 깔린 확장 판 — CLI /health.extVersion(확장이 ?ver= 로 알린 값) · 옛 CLI·확장 안 붙음 = null
            extLatest: { latest: '', min: '' }, // 서버 /api/ext/latest-version — 값 없으면 '' (띠 0)
            extLatestAt: 0,
            busyTabId: Math.random().toString(36).slice(2, 12), // 이 탭 이름 — /busy-beat 로 제 바쁨을 알린다
            cliOldNotice: '',            // 옛 CLI 안내 한 줄(서버가 준 문구)
            cliOldNoticeAsked: '',       // 이 화면에서 이미 물어본 CLI 버전 — 30초 주기마다 다시 묻지 않는다
            cliCheckInterval: null,
            activeOsTab: navigator.platform.includes('Mac') ? 'mac' : 'windows',
            navTabHint: '',
            navTabHintTimer: null,
            // 쿠팡 로그인 안내 — 확장이 준 것을 그대로 담는다(없으면 null = 띄울 것 없음)
            loginNotice: null,
            loginNoticeTimer: null,
            loginNoticeAskedAt: 0,
		}
	},
    watch: {
        // 바쁨 문(판 #308) — 받기·작업이 시작·끝나는 순간 CLI 에 바로 알린다(30초 주기를 기다리지 않는다)
        busyReasonsKey() {
            this.sendBusyBeat();
        },
        // 주소가 창을 열라고 하면(라우터 meta.openModal — /coupang-accounts = 멀티계정관리 창) 그 창을 띄운다.
        // screen.open(에이전트)이 쿠팡 쇼핑 계정 등록 안내 때 이 주소를 연다. 입력·저장은 사용자가 한다
        $route: {
            immediate: true,
            handler(to) {
                const id = to && to.meta && to.meta.openModal;
                if (id) this.$nextTick(() => this.$bvModal.show(id));
            },
        },
    },
    mounted(){
        // 쿠패스 직원 계정의 임시 비밀번호 — 첫 로그인(또는 초기화 후) 때 변경 강제
        if (this.$store.state.user && this.$store.state.user.mustChangePw) {
            this.forcePwChange = true;
            this.$nextTick(() => this.$bvModal.show('changePassword'));
        }
        this.setpaymenttext();
        this.setShowSellerInfo();
        this.setGeminiAPIKey();
        this.checkCliStatus();
        this.cliCheckInterval = setInterval(() => this.checkCliStatus(), 30000);
        this.refreshAutoCollectDot();
        this.showPendingAccountSyncNotice();
        // 확장은 쿠팡 세션이 끊길 때 알려주는데, 그 순간 화면이 안 열려 있었을 수 있다.
        // 게다가 「끊겼다」는 기록은 도구가 실제로 쿠팡을 부르다 튕겼을 때만 남아서,
        // 아무 도구도 안 부른 채 끊기면 **아무 표시도 없는 창**이 생긴다.
        // ⇒ 이 화면이 보이는 동안 느슨한 간격으로 **지금 상태를 확인**해 달라고 한다.
        //    확인은 읽기 한 번이고, 이 물음이 쿠팡 로그인을 시도하게 만들지는 않는다.
        this.askLoginNotice(true);
        this.loginNoticeTimer = setInterval(() => this.askLoginNotice(), LOGIN_NOTICE_POLL_MS);
        // 화면이 숨겨져 있는 동안은 쉰다. 다시 보이면 그때 한 번 확인한다.
        this.loginNoticeVisibilityHandler = () => {
            if (document.hidden) return;
            this.askLoginNotice();
        };
        document.addEventListener('visibilitychange', this.loginNoticeVisibilityHandler);
        // 머리 줄 높이는 탭 줄바꿈 따라 61~105px 로 바뀐다(10-27 잰 값) — 오른쪽 위 토스트 자리(custom.css)가 따라오게 CSS 변수로 둔다
        this.headerHeightObserver = new ResizeObserver(() => {
            const el = this.$refs.topNavbar;
            if (el) document.documentElement.style.setProperty('--cp-header-h', `${Math.ceil(el.getBoundingClientRect().bottom)}px`);
        });
        // border-box — 폭에 따라 안 높이(73)는 그대로 두고 위아래 padding 만 바뀌는 때가 있어 content-box 로는 안 깸(10-27 1440↔992 잰 값)
        this.headerHeightObserver.observe(this.$refs.topNavbar, { box: 'border-box' });
    },
    created() {
        // 메시지 이벤트 리스너 추가 (자동수집 상태 토스트 메시지용)
        this.messageEventHandler = async(event) => {
            // CLI 미감지 메시지 처리
            // 확장 신호만 믿지 않고 화면이 직접 다시 잰다 — CLI 가 연결돼 있으면 창이 화면을 가리지 않게(판 #720)
            if (event.data.type === 'cliNotFound') {
                await this.checkCliStatus();
                if (!this.cliConnected) this.showCliGuide = true;
            }
            // autoCollectStatus 메시지 처리
            // 자동수집이 끝난 뒤 확장이 미뤄 둔 쿠팡 계정 맞춤을 했다 — 결과 한 줄
            if (event.data.res === 'coupangAccountSynced' && event.data.deferred) {
                const notice = accountSyncNotice(event.data, { suppliercode: event.data.suppliercode, companyid: event.data.companyid });
                if (notice) this.showAccountSyncMessage(notice.text);
            }
            if (event.data.type === 'autoCollectStatus') {
                // 여러 계정이 차례로 수집된다 — 어느 계정 알림인지 앞에 붙인다(확장이 실행 중에만 실어 준다)
                const who = event.data.companyid || event.data.suppliercode;
                this.updateAutoCollectStatus(who ? `[${who}] ${event.data.message}` : event.data.message);
            }
            // 쿠팡 로그인이 풀렸다(또는 돌아왔다)
            if (event.data.type === 'loginNotice') {
                this.applyLoginNotice(event.data.notice);
            }

            // 수집 진행률 표시
            if (event.data.res && (event.data.res === 'growthdbratio' || event.data.res === 'growthDbRatio')){
                var loadingtext = event.data.text + event.data.ratio.toFixed(0) + '%';
                this.updateAutoCollectStatus(loadingtext);
            }
            if (event.data.res && event.data.res === 'keywordanalysisstatusratio') {
				loadingtext = event.data.text + '...(' + event.data.status + ")";
				this.updateAutoCollectStatus(loadingtext);
			}
        };
        window.addEventListener('message', this.messageEventHandler);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.messageEventHandler);
        if (this.cliCheckInterval) clearInterval(this.cliCheckInterval);
        if (this.navTabHintTimer) clearTimeout(this.navTabHintTimer);
        if (this.copiedCmdTimer) clearTimeout(this.copiedCmdTimer);
        if (this.loginNoticeTimer) clearInterval(this.loginNoticeTimer);
        if (this.loginNoticeVisibilityHandler) {
            document.removeEventListener('visibilitychange', this.loginNoticeVisibilityHandler);
        }
        if (this.headerHeightObserver) this.headerHeightObserver.disconnect();
        document.documentElement.style.removeProperty('--cp-header-h');
    },
    methods: {
        goTab(tab) {
            if (tab.name === this.$route.name) return;
            this.$router.push(tab.path).catch(e => {
                // 같은 경로 재이동은 무시, 그 외에는 남긴다
                if (e && e.name !== 'NavigationDuplicated') console.error('[navTabs] 탭 이동 실패', e);
            });
        },
        closeTab(tab) {
            const tabs = this.navTabs;
            const idx = tabs.findIndex(t => t.name === tab.name);
            const isActive = tab.name === this.$route.name;
            this.$store.commit('NAVTAB_CLOSE', tab.name);
            if (!isActive) return;
            // 닫은 게 현재 탭이면 오른쪽 → 없으면 왼쪽 탭으로 이동
            const next = this.navTabs[idx] || this.navTabs[idx - 1];
            if (next) this.goTab(next);
        },
        togglePin(tab) {
            const nav = this.$store.state.navTabs;
            if (!tab.pinned && this.navTabs.filter(t => t.pinned).length >= nav.maxPinned) {
                this.showNavTabHint(`탭 고정은 ${nav.maxPinned}개까지 가능합니다.`);
                return;
            }
            this.$store.commit('NAVTAB_TOGGLE_PIN', tab.name);
        },
        showNavTabHint(message) {
            this.navTabHint = message;
            if (this.navTabHintTimer) clearTimeout(this.navTabHintTimer);
            this.navTabHintTimer = setTimeout(() => {
                this.navTabHint = '';
                this.navTabHintTimer = null;
            }, 2500);
        },
        async saveAPI(){
			try{
				var result = await axios.post('/api/setDatalabApi',{clientId:this.clientId,clientSecret:this.clientSecret});
				if(result.data.요청결과 == 'success'){
					// 서버는 봉투로만 저장한다(새 날값 0) — 화면 저장소에는 «저장됨» 만 켠다.
					// 1단계(D-162 ㉠): 서버가 옛 날값을 안 지우므로 저장소의 날값(옛 확장에 넘기는 값)도 그대로 둔다 — 지우기는 2단계
					var obj = this.deepClone(this.$store.state.settings[0]);
					obj.hasDatalabKey = true;
					this.$store.commit('settingsupdate',[obj])
					this.clientId = '';
					this.clientSecret = '';
					alert('저장완료')
				} else {
					alert(typeof result.data.result === 'string' ? result.data.result : '저장실패(510)');
				}
			}catch(e){
				alert('저장실패(514)')
				console.log(e)
			}
		},
        deepClone(obj) {
			if (obj === null || typeof obj !== "object") {
				return obj
			}

			const result = Array.isArray(obj) ? [] : {}

			for (let key of Object.keys(obj)) {
				result[key] = this.deepClone(obj[key])
			}

			return result
		},
        setGeminiAPIKey(){
            if(this.$store.state.user.auth.showAI && this.$store.state.settings[0].geminiAPIKey){
                this.geminiAPIKey = this.$store.state.settings[0].geminiAPIKey;
            }
        },
        setShowSellerInfo(){
            if(this.$store.state.user.auth.showSellerInfo === false){
                this.showSellerInfo = false;
            }
        },
        setpaymenttext(){
            this.now = this.$store.state.user.paydate;
            if(this.now){
                this.showpayment = true;
            } else {
                this.showpayment = false;
            }
            if(this.$store.state.user.nextpayment){
                this.paymenttext = '구독취소';
                this.paymentcontent = '구독취소 시 다음달 결제일 부터 구독결제가 종료됩니다.'
            } else {
                this.paymenttext = '구독시작';
                this.paymentcontent = '구독시작 시 다음달 결제일 부터 구독결제가 시작됩니다.'
            }
            this.changebtnclass();
        },
        changebtnclass(){
            if(this.paymenttext == '구독취소'){
                this.btnclass = 'outline-secondary';
            } else {
                this.btnclass = 'outline-success';
            }
        },
        changepaymentstatus(){
            if(this.paymenttext == '구독취소'){
                if(!confirm('구독취소 시 다음 결제일부터 결제가 종료됩니다. 이미 결제하신 기간은 그대로 이용하실 수 있고, 저장하신 데이터는 지워지지 않습니다. 계속하시겠습니까?')){
                    return
                }
            }
            axios.post('/api/login/changepaymentstatus',{nextpayment : this.$store.state.user.nextpayment})
            .then((result)=>{
                if(result.data.요청결과 == 'success'){
                    alert(result.data.message);
                    this.$store.commit('userupdate',result.data.userinfo);
                    this.setpaymenttext();
                } else {
                    alert(result.data.message);
                }
            })
            .catch((e)=>{
                console.log(e)
            })
        },
        // ── 계정 전환 ──────────────────────────────────────────────
        // 비번은 추가할 때 한 번만 확인하고 저장하지 않는다. 서버가 '전환해도 된다'는
        // 연결만 들고 있고, 전환은 세션을 갈아끼운 뒤 화면을 통째로 새로고침한다.
        // 이 회사 데이터가 마지막으로 바뀐 시각. 보관해 둔 store 가 아직 쓸 만한지 판단하는 기준이다.
        // 확인할 수 없으면 null → 그때는 보관하지 않는다(낡은 값을 되살리는 것보다 다시 받는 게 낫다)
        async fetchDataStamp() {
            try {
                const res = await axios.post('/api/growth/getLedgerStamp', {});
                if (res.data?.res !== 'success') return null;
                return res.data.stamp || '';
            } catch (e) {
                console.error('[계정전환] 데이터 변경시각 확인 실패', e);
                return null;
            }
        },

        /**
         * @param {string} email 바꿀 쿠플러스 계정
         * @param {object} [opts] 멀티계정관리 줄에서 온 값
         * @param {string} [opts.suppliercode] 그 계정의 쿠팡 판매자코드 — 있으면 쿠팡 계정도 함께 맞춘다(스위치 켜짐일 때)
         * @param {string} [opts.companyid]
         * @param {boolean} [opts.skipCoupangSync] 쿠팡 쪽을 이미 바꾼 뒤 쿠플러스만 따라 바꾸는 경우
         */
        async switchAccount(email, opts = {}) {
            if (this.switching || email === this.email) return;

            // 수집은 확장이 쿠팡에 로그인해 긁는다. 도중에 계정을 바꾸면 쿠팡 세션이
            // 밀려 돌고 있던 수집이 조용히 깨진다. 저장도 지금 계정 기준으로 쌓인다
            if (this.switchBlockedReason) {
                alert(this.switchBlockedReason);
                return;
            }
            // 확인창은 두지 않는다 — 잘못 눌러도 다시 누르면 되돌아온다.
            // 매번 묻는 창은 몇 번 지나면 읽히지 않고, 정말 막아야 할 경고(위 수집·저장 중)의
            // 무게만 깎는다. 지금 계정은 헤더 버튼에 계속 떠 있어 잘못 눌러도 바로 보인다

            this.switching = true;
            try {
                // 떠나기 전에 지금 계정의 store 를 보관해 둔다. 돌아왔을 때 이걸 꺼내 쓰면
                // 상품DB(큰 회사는 16MB) 같은 걸 다시 받지 않는다.
                // 아직 전환 전이라 여기서 받는 stamp 는 '지금 계정' 것이다
                await storeSnapshot.saveSnapshot(
                    this.$store.state.user?._id,
                    this.$store.state,
                    await this.fetchDataStamp()
                );

                const res = await axios.post('/api/accountLink/switch', { email });
                if (res.data?.res !== 'success') {
                    alert(res.data?.alert || '계정 전환에 실패했습니다.');
                    return;
                }
                // 쿠플러스·쿠팡 계정 함께 전환 — 쿠플러스는 이미 바뀌었다. 쿠팡이 실패해도 쿠플러스는 되돌리지 않고 알리기만 한다
                if (opts.suppliercode && !opts.skipCoupangSync && (await loadAccountSync()) === true) {
                    this.showAccountSyncMessage('쿠팡 계정을 함께 바꾸는 중입니다…');
                    const notice = await syncCoupangAccount(
                        { suppliercode: opts.suppliercode, companyid: opts.companyid || '', email },
                        makeSwitchConfirm(this),
                    );
                    if (notice) {
                        try {
                            sessionStorage.setItem(ACCOUNT_SYNC_NOTICE_KEY, notice.text);
                        } catch (e) {
                            console.error('[계정전환] 알림 보관 실패', e);
                        }
                        // 새로고침 전에도 잠깐 보여 준다 — 새로고침 뒤 알림을 못 띄우는 경우가 있어도 한 번은 읽히게
                        this.showAccountSyncMessage(notice.text);
                        await new Promise(r => setTimeout(r, 2500));
                    }
                }
                // 장부 캐시는 비우지 않는다. 키가 계정별(v7|계정id|기간)이라 남의 것을 볼 수 없고,
                // 서버가 준 변경시각으로 낡았는지도 걸러낸다. 여기서 비우면 두 계정을 오가며
                // 비교할 때(= 전환의 주 용도) 매번 다시 받게 된다
                // 보던 화면 그대로 새로 그린다 — 계정을 바꾸는 이유가 대개
                // '같은 화면을 다른 계정으로 보려고'라서 대시보드로 튕기면 매번 다시 찾아가야 한다.
                // 새 계정에 그 화면 권한이 없으면 라우터 가드가 다시 돌면서 보내준다.
                // ('/' 로 보내면 안 된다 — 그건 로그인 경로다, router/index.js 의 loginchildRoute)
                window.location.reload();
            } catch (e) {
                console.error('[계정전환] 전환 실패', e);
                alert('계정 전환에 실패했습니다.');
            } finally {
                this.switching = false;
            }
        },
        logout() {
            axios.post('/api/logout')
            .then(async (result) =>{
                console.log(result)
                console.log(result.data)
                console.log(result.data.loginstatus)
                if (result.data.loginstatus == false) {
                    localStorage.removeItem('wasLoggedIn');
                    // 공용 PC 에서 다음 사람이 앞사람 숫자를 보지 않도록 받아둔 것도 버린다
                    await ledgerCache.clearAll();
                    await storeSnapshot.clearAllSnapshots();
                    this.$store.commit('resetState');
                    this.$router.push({name: 'auth.login'})
                }
            })
            .catch(console.log)
        },
        // 직원 첫 로그인 창에서는 서버의 한국어 오류 문구를 중국어로 바꿔 보여준다
        pwChangeMessage(msg) {
            if (!this.forcePwChange) return msg;
            const zh = {
                '현재 비밀번호가 잘못 입력 됐습니다.': '当前密码输入错误',
                '변경 전 비밀번호와 동일합니다.': '新密码不能与原密码相同',
                '8~20자 이내, 영문+숫자+특수문자($제외)를 포함시켜 주세요': '密码需8~20位，包含英文+数字+特殊字符（不含$）',
                '변경 실패': '修改失败',
                'server error': '服务器错误，请稍后再试'
            };
            return zh[msg] || msg;
        },
        onClickPasswordChange() {
          if (this.newPassword !== this.checkNewPassword) {
              alert(this.forcePwChange ? '两次输入的新密码不一致' : '새 비밀번호와 비밀번호 확인이 일치하지 않습니다.')
          } else {
              axios.post('/api/auth/change-password', {currentPwd: this.currentPassword, newPwd: this.newPassword, email: this.$store.state.user.email})
                  .then((response) => {
                      if (response.data.result === 'success') {
                          alert(this.forcePwChange ? '密码已修改' : '비밀번호가 변경됐습니다.')
                          if (this.forcePwChange) {
                              this.forcePwChange = false
                              this.$store.commit('userupdate', Object.assign({}, this.$store.state.user, { mustChangePw: false }))
                          }
                          this.$bvModal.hide('changePassword')
                          this.currentPassword = ''
                          this.newPassword = ''
                          this.checkNewPassword = ''
                      } else {
                          alert(this.pwChangeMessage(response.data.message))
                          console.log(response.data)
                      }
                  })
                  .catch((error) => {
                      alert(this.pwChangeMessage(error.response && error.response.data))
                  })
          }
        },
        async onClickGeminiAPIChange() {
            if (!this.geminiAPIKey) {
                alert('Gemini API를 입력해 주세요')
                return
            }
            try{
                var res = await axios.post('/api/setGeminiApi', {key: this.geminiAPIKey})
                if (res.data.요청결과 === '저장완료') {
                    alert('Gemini API Key가 적용 되었습니다.')
                    this.$store.commit('settingsupdateparameter',{key:'geminiAPIKey',value:this.geminiAPIKey});
                    this.$store.commit('settingsupdateparameter',{key:'hasGeminiKey',value:!!this.geminiAPIKey});
                    this.$bvModal.hide('geminiApi');
                } else {
                    alert(res.data.요청결과)
                    console.log(res.data)
                } 
            } catch(error){
                alert(error.response.data)
            }
        },

        /**
         * 계정 버튼 점 — 어느 계정이든 자동수집 일정이 있으면 켠다.
         * 새 확장은 계정 목록에 일정 개수(autoCollect.scheduleCount)를 준다.
         * 구 확장은 그게 없다 → 예전처럼 지금 계정 설정만 본다.
         */
        async refreshAutoCollectDot() {
            try {
                const ext = await askExtension('getCoupangAccounts', {}, 'coupangAccounts', 5000);
                const accounts = (ext && ext.accounts) || [];
                if (accounts.some(a => a && a.autoCollect)) {
                    this.autoCollectScheduled = accounts.some(a => a.autoCollect && a.autoCollect.scheduleCount > 0);
                    return;
                }
                const sc = this.$store.state.user && this.$store.state.user.suppliercode;
                if (!sc) {
                    this.autoCollectScheduled = false;
                    return;
                }
                const r = await askExtension('getAutoCollectSettings', { suppliercode: sc }, 'autoCollectSettings', 5000);
                const schedules = (r && r.settings && r.settings.schedules) || {};
                this.autoCollectScheduled = Object.values(schedules).some(v => v && v.type && v.type !== 'none');
            } catch (e) {
                console.error('[헤더] 자동수집 일정 확인 실패', e);
            }
        },
        // 자동수집 상태 메시지 업데이트 함수 (헤더 메시지 수신·자동수집 창에서 호출)
        // 계정 전환 직전에 담아 둔 쿠팡 계정 맞춤 결과를 새로고침 뒤 한 번 보여준다
        showPendingAccountSyncNotice() {
            let text = '';
            try {
                text = sessionStorage.getItem(ACCOUNT_SYNC_NOTICE_KEY) || '';
                sessionStorage.removeItem(ACCOUNT_SYNC_NOTICE_KEY);
            } catch (e) {
                console.error('[계정전환] 알림 읽기 실패', e);
            }
            if (text) this.showAccountSyncMessage(text);
            // 자동수집이 끝난 뒤 맞춘 결과를 그때 화면이 못 받았으면(새로고침 등) 확장이 한 번 더 내려준다
            askExtension('getAccountSync', {}, 'accountSync', 2000).then((d) => {
                const last = d && d.lastResult;
                if (!last) return;
                const notice = accountSyncNotice(last, { suppliercode: last.suppliercode, companyid: last.companyid });
                if (notice) this.showAccountSyncMessage(notice.text);
            }).catch(e => console.error('[계정전환] 미룬 전환 결과 조회 실패', e));
        },
        showAccountSyncMessage(text) {
            this.accountSyncMessage = text;
            if (this.accountSyncMessageTimer) clearTimeout(this.accountSyncMessageTimer);
            this.accountSyncMessageTimer = setTimeout(() => {
                this.accountSyncMessage = '';
                this.accountSyncMessageTimer = null;
            }, 10000);
        },
        updateAutoCollectStatus(message) {
            this.autoCollectMessage = message;
            // 기존 타이머 클리어 후 새 타이머 설정 (마지막 메시지 후 10초 경과 시 제거)
            if (this.autoCollectMessageTimer) {
                clearTimeout(this.autoCollectMessageTimer);
            }
            this.autoCollectMessageTimer = setTimeout(() => {
                this.autoCollectMessage = '';
                this.autoCollectMessageTimer = null;
            }, 10000);
        },

        /**
         * 「지금 쿠팡 로그인이 풀렸나」를 확인해 달라고 한다.
         *
         * ⚠ **화면이 숨겨져 있으면 묻지 않는다.** 확인 한 번이 쿠팡에 나가는 요청 한 번이라,
         *    아무도 안 보는 동안 주기 트래픽을 만들면 안 된다. 다시 보일 때 확인한다.
         * ⚠ 이 물음은 로그인 시도가 아니다. 확장도 CLI 도 여기서 비밀번호를 쓰지 않는다.
         *
         * @param {boolean} force 화면이 막 열린 경우. 직전 확인과의 간격을 따지지 않는다.
         */
        askLoginNotice(force = false) {
            if (typeof document !== 'undefined' && document.hidden) return;
            const now = Date.now();
            if (!force && now - this.loginNoticeAskedAt < LOGIN_NOTICE_MIN_GAP_MS) return;
            this.loginNoticeAskedAt = now;
            window.postMessage({ type: 'requestLoginNotice' }, '*');
        },

        /**
         * 확장이 알려준 쿠팡 로그인 상태를 화면에 반영한다.
         * 문구를 여기서 만들지 않는다 — 받은 것을 그대로 쓴다.
         */
        applyLoginNotice(notice) {
            // 헤더 「쿠팡 로그인」 버튼만 켜고 끈다. 창은 스스로 띄우지 않는다(누르면 멀티계정관리 창).
            this.loginNotice = notice && notice.active ? notice : null;
        },

        async checkCliStatus() {
            if (this.cliUpdating) return;
            // 데몬 없는 빌드(로컬 기본) — 묻지 않고 «연결 안 됨»
            if (!CLI_DAEMON_ENABLED) {
                this.cliConnected = false;
                this.cliVersion = null;
                return;
            }
            try {
                const controller = new AbortController();
                const timeout = setTimeout(() => controller.abort(), 3000);
                const res = await fetch(cliDaemonUrl('/health'), { signal: controller.signal });
                clearTimeout(timeout);
                const data = await res.json();
                this.cliConnected = true;
                this.cliVersion = data.version;
                this.cliBusy = data.busy;
                this.extInstalledVersion = typeof data.extVersion === 'string' ? data.extVersion : null;
                this.sendBusyBeat();
                this.checkCliUpdate();
                this.checkExtUpdate();
                this.askCliOldNotice(data.version);
            } catch (e) {
                this.cliConnected = false;
                this.cliVersion = null;
                this.extInstalledVersion = null;
            }
        },
        // 확장 최신·하한 판을 서버에 묻는다(10분에 한 번) — 값 넣기는 웹스토어 올릴 때 배포 몫 · 하한 켜기는 saram 몫
        async checkExtUpdate() {
            if (!this.extInstalledVersion) return;
            if (this.extLatestAt && Date.now() - this.extLatestAt < 10 * 60 * 1000) return;
            this.extLatestAt = Date.now();
            try {
                const res = await axios.get('/api/ext/latest-version');
                const d = res.data || {};
                this.extLatest = { latest: typeof d.latest === 'string' ? d.latest : '', min: typeof d.min === 'string' ? d.min : '' };
            } catch (e) {
                console.error('[확장] 최신 판 확인 실패:', e && e.message);
            }
        },
        // 바쁨 문(판 #308) — 이 탭의 받기·작업 중 여부를 CLI 에 알린다(30초마다 · CLI 는 90초 지나면 안 센다)
        async sendBusyBeat() {
            if (!this.cliBusy) return; // 옛 CLI 는 /busy-beat 를 모른다
            const reasons = tabBusyReasons(this.$store.state);
            try {
                await fetch(cliDaemonUrl('/busy-beat'), {
                    method: 'POST',
                    body: JSON.stringify({ tabId: this.busyTabId, busy: reasons.length > 0, reasons }),
                    signal: AbortSignal.timeout(3000),
                });
            } catch (e) {
                console.error('[cli] 바쁨 알림 실패:', e && e.message);
            }
        },
        // 옛 CLI(1.3.0 미만)면 서버에 안내를 띄울지 묻는다 — 하루 한 번 판정·문구는 서버(tool-exec/cli-old-notice.js)
        async askCliOldNotice(version) {
            const cmp = compareCliVersion(version, CLI_OLD_BELOW);
            if (cmp === null || cmp >= 0 || this.cliOldNoticeAsked === version) return;
            this.cliOldNoticeAsked = version;
            try {
                const res = await axios.post('/api/cli/old-notice', { version });
                if (res.data && res.data.show && res.data.message) this.cliOldNotice = res.data.message;
            } catch (e) {
                console.error('[cli] 옛 CLI 안내 확인 실패:', e && e.message);
            }
        },
        async checkCliUpdate() {
            if (this.cliUpdating || this.cliUpdateFailed) return;
            // 개발 모드 CLI(__VERSION__)는 업데이트 체크 스킵
            if (this.cliVersion === '__VERSION__') return;
            try {
                const res = await fetch('https://www.couplus.co.kr/api/cli/latest-version', { signal: AbortSignal.timeout(5000) });
                const data = await res.json();
                this.cliLatestVersion = data.version;
                this.cliUpdateAvailable = this.cliVersion && data.version && this.cliVersion !== data.version;
                this.cliUpdateStuck = this.isCliUpdateStuck(this.cliVersion, data.version, this.cliUpdateAvailable);
                // 바쁨 문(판 #308) — 이 탭·CLI 모두 받기·작업 0 이면 스스로 업데이트, 바쁘면 배너만 두고 30초 뒤 다시 본다.
                const tabReasons = tabBusyReasons(this.$store.state);
                const mode = cliUpdateMode({ tabReasons, cliBusy: this.cliBusy });
                this.cliUpdateWaitReasons = mode === 'wait' ? tabReasons.concat(this.cliBusy.reasons || []) : [];
                if (this.cliUpdateAvailable && mode === 'auto') {
                    this.triggerCliUpdate();
                    return;
                }
                // 옛 CLI(바쁨을 못 알림)는 예전처럼 모달로 안내 — 작업 중 CLI 재시작 끊김 방지. 1회만 자동으로 연다.
                if (this.cliUpdateAvailable && mode === 'ask' && !this.cliUpdatePrompted) {
                    this.cliUpdatePrompted = true;
                    this.showCliGuide = true;
                }
            } catch (e) { /* ignore */ }
        },
        // 같은 「현재→최신」 차이를 처음 본 시각을 브라우저에 남겨 두고, CLI_UPDATE_STUCK_MS 넘게 이어지는지 본다
        isCliUpdateStuck(current, latest, available) {
            try {
                if (!available) {
                    localStorage.removeItem(CLI_UPDATE_PENDING_KEY);
                    return false;
                }
                const saved = JSON.parse(localStorage.getItem(CLI_UPDATE_PENDING_KEY) || 'null');
                if (saved && saved.from === current && saved.to === latest && saved.since) {
                    return Date.now() - saved.since >= CLI_UPDATE_STUCK_MS;
                }
                localStorage.setItem(CLI_UPDATE_PENDING_KEY, JSON.stringify({ from: current, to: latest, since: Date.now() }));
            } catch (e) {
                console.error('[cli] 업데이트 지연 기록 실패:', e);
            }
            return false;
        },
        async triggerCliUpdate() {
            if (this.cliUpdating) return;
            this.cliUpdating = true;
            try {
                const res = await fetch(cliDaemonUrl('/self-update'), { method: 'POST', signal: AbortSignal.timeout(5000) });
                const data = await res.json();
                if (data.status === 'busy') {
                    // 받기·작업 중 — CLI 가 한가해지면 스스로 업데이트한다(창 안에 까닭을 보인다)
                    this.cliUpdating = false;
                    this.cliUpdateWaitReasons = Array.isArray(data.reasons) && data.reasons.length ? data.reasons : ['작업 중'];
                    return;
                }
                if (data.status !== 'updating') {
                    // 구 CLI — /self-update 미지원 → 수동 가이드
                    this.cliUpdating = false;
                    this.cliUpdateFailed = true;
                    this.showCliGuide = true;
                    return;
                }
            } catch (e) {
                // 연결 끊김(CLI 종료) 또는 timeout → 정상 진행
            }
            this.cliConnected = false;
            this.waitForCliRestart();
        },
        waitForCliRestart(attempt = 0) {
            if (attempt > 30) { // 최대 60초
                this.cliUpdating = false;
                this.cliUpdateFailed = true;
                this.showCliGuide = true;
                return;
            }
            setTimeout(async () => {
                try {
                    const res = await fetch(cliDaemonUrl('/health'), { signal: AbortSignal.timeout(3000) });
                    const data = await res.json();
                    if (data.version && data.version === this.cliLatestVersion) {
                        this.cliConnected = true;
                        this.cliVersion = data.version;
                        this.cliUpdateAvailable = false;
                        this.cliUpdating = false;
                    } else {
                        this.waitForCliRestart(attempt + 1);
                    }
                } catch (e) {
                    this.waitForCliRestart(attempt + 1);
                }
            }, 2000);
        },
        copyCommand(cmd, key) {
            navigator.clipboard.writeText(cmd).then(() => {
                this.copiedCmdKey = key;
                if (this.copiedCmdTimer) clearTimeout(this.copiedCmdTimer);
                this.copiedCmdTimer = setTimeout(() => { this.copiedCmdKey = ''; }, 2000);
            });
        },
        reloadPage() {
            this.showCliGuide = false;
            window.location.reload();
        }

    }


}
</script>

<style scoped lang="scss">
/* ── 메뉴 탭 바 ───────────────────────────────────────────── */
/* 브라우저 탭처럼 : 위 모서리만 둥글고 아래는 헤더 바닥에 붙어 콘텐츠와 이어진다 */
.nav-tab-bar {
    position: relative;
    align-items: flex-end;
    gap: 2px;
    flex: 1 1 auto;
    min-width: 0;
    height: 73px;
    padding: 0 12px;
    overflow: hidden;
}
.nav-tab {
    position: relative;
    display: flex;
    align-items: center;
    gap: 2px;
    /* 브라우저 탭처럼 개수가 늘면 폭이 줄어든다 */
    flex: 1 1 0;
    max-width: 160px;
    min-width: 68px;
    height: 36px;
    margin-bottom: -1px;
    padding: 0 6px 0 10px;
    border: 1px solid #e3e6ef;
    border-bottom-color: transparent;
    border-radius: 8px 8px 0 0;
    background: #f0f2f7;
    color: #6c757d;
    font-size: 13px;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s, color 0.15s;

    &:hover {
        background: #e7eaf3;
        color: #374151;
    }
    &--active {
        background: #fff;
        border-color: #d7dbe8;
        border-bottom-color: #fff;
        color: #3a57e8;
        font-weight: 600;
        z-index: 2;

        /* 활성 탭 상단 강조선 */
        &::before {
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            right: -1px;
            height: 3px;
            border-radius: 8px 8px 0 0;
            background: #3a57e8;
        }
    }
}
.nav-tab__label {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.nav-tab__pin,
.nav-tab__close {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: inherit;
    font-size: 13px;
    line-height: 1;
    opacity: 0;
    transition: opacity 0.15s, background 0.15s;

    &:hover {
        background: rgba(0, 0, 0, 0.08);
    }
}
/* 고정된 탭은 핀을 항상 보여준다 (상태 표시) */
.nav-tab--pinned .nav-tab__pin {
    opacity: 1;
    color: #3a57e8;
}
.nav-tab:hover .nav-tab__pin,
.nav-tab:hover .nav-tab__close,
.nav-tab--active .nav-tab__close {
    opacity: 0.6;
}
.nav-tab__pin:hover,
.nav-tab__close:hover {
    opacity: 1 !important;
}
/* 대시보드는 body.dark 를 켠다 — 밝은 탭 색이 그대로면 흰 배경에 흰 글씨가 된다 */
body.dark .nav-tab {
    border-color: #2c3244;
    background: #1e2331;
    color: #a3aac0;

    &:hover {
        background: #272d3d;
        color: #e6e9f2;
    }
    &.nav-tab--active {
        background: #12151f;
        border-color: #3a4160;
        border-bottom-color: #12151f;
        color: #6b8afd;
    }
}
.nav-tab-hint {
    position: absolute;
    left: 12px;
    bottom: 6px;
    padding: 3px 8px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    font-size: 11px;
    white-space: nowrap;
    pointer-events: none;
}

/* ── 우측 참고 링크 그룹 (조용한 위계) ───────────────────── */
.header-ref-item {
    display: flex;
    align-items: center;
    height: 73px;
}
.header-ref-link,
::v-deep .header-ref-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1px;
    width: 52px;
    padding: 4px 0;
    border-radius: 6px;
    color: #8a92a6;
    font-size: 10px;
    line-height: 1.2;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;

    i {
        font-size: 18px;
        line-height: 1;
    }
    &:hover {
        background: #f2f4f9;
        color: #3a57e8;
        text-decoration: none;
    }
}
.header-group-divider {
    width: 1px;
    height: 26px;
    margin: 0 10px;
    background: #e3e6ef;
}

/* 다크 테마는 헤더 안의 span 을 흰색으로 칠한다(.dark .iq-top-navbar span).
   hover·열림 때는 배경이 밝아지므로 그대로 두면 글자가 묻힌다 — 그때만 되돌린다 */
.header-ref-item .header-ref-link:hover span,
.header-ref-item.show > .header-ref-link span,
.header-ref-item .header-ref-link[aria-expanded="true"] span,
::v-deep .header-ref-item .header-ref-link:hover span {
    color: inherit;
}

/* 드롭다운이 열려 있는 동안에도 눌린 상태로 보이게 */
.header-ref-item.show > .header-ref-link,
.header-ref-item .header-ref-link[aria-expanded="true"] {
    background: #f2f4f9;
    color: #3a57e8;
}

/* 버튼도 링크와 같은 모양으로 (자동수집 버튼은 자식 컴포넌트 안에 있다) */
.header-ref-link--btn,
::v-deep .header-ref-link--btn {
    border: 0;
    background: transparent;
}

/* 계정 이름은 길어질 수 있어 폭을 조금 더 준다 */
.header-ref-link--wide {
    width: auto;
    min-width: 52px;
    max-width: 104px;
    padding-left: 8px;
    padding-right: 8px;

    &.dropdown-toggle::after { display: none; }
}
.header-ref-label {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 상태 점은 아이콘 어깨에 붙인다 (라벨 폭을 흔들지 않게) */
.header-ref-icon,
::v-deep .header-ref-icon {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.header-ref-dot,
::v-deep .header-ref-dot {
    position: absolute;
    top: -1px;
    right: -4px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #c2c7d6;

    &.connected { background: #2ecc71; }
}

/* 조치가 필요한 상태(CLI 미연결)만 빨갛게 남긴다 */
.header-ref-link.is-alert {
    color: #dc3545;

    .header-ref-dot { background: #dc3545; }
    &:hover { color: #dc3545; background: #fdeaec; }
}

.pw-input {
    margin-bottom: 25px;
}
.change-button-area {
    display: flex;
    justify-content: center;
    align-items: center;
    .change-button {
        width: 15%;
    }
}
.header-action-btn {
    font-size: 16px !important;
    padding: 6px 12px !important;
    line-height: 24px !important;
    box-sizing: border-box;
    vertical-align: middle;
}
// 계정관리 드롭다운 a 태그도 flex 정렬로 통일
.caption-content > a.search-toggle {
    display: flex !important;
    align-items: center !important;
    line-height: normal !important;
    height: 73px;
    padding: 0 10px 0 4px !important;
}
#changePassword {
    max-width: 50%;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

/* (추가) 자동수집 상태 토스트 메시지 스타일 */
.auto-collect-toast {
    position: fixed; /* 화면 고정 위치 */
    top: 80px; /* 헤더 바로 아래 위치 (필요에 따라 조정) */
    right: 20px;
    z-index: 10000; /* 다른 요소들보다 위에 표시 */
    background-color: rgba(0, 0, 0, 0.7); /* 반투명 배경 */
    color: #fff;
    padding: 10px 15px;
    border-radius: 4px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    /* 애니메이션 제거하여 메시지가 지속적으로 표시되도록 함 */
    /* animation: fadein 0.5s, fadeout 0.5s 4.5s; */
    transition: opacity 0.5s;
}

.auto-collect-toast-enter-active, .auto-collect-toast-leave-active {
    transition: opacity 0.5s;
}
.auto-collect-toast-enter, .auto-collect-toast-leave-to /* .leave-active for <2.1.8 */ {
    opacity: 0;
}

/* 옛 CLI 업데이트 안내 한 줄 */
.cli-old-notice {
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10000;
    max-width: calc(100vw - 32px);
    display: flex;
    align-items: center;
    gap: 10px;
    background: #fff3cd;
    color: #856404;
    border: 1px solid #ffe08a;
    padding: 10px 14px;
    border-radius: 6px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.cli-old-notice-link {
    border: 0;
    background: #856404;
    color: #fff;
    border-radius: 4px;
    padding: 4px 10px;
    font-size: 13px;
    white-space: nowrap;
    cursor: pointer;
}
.cli-old-notice-close {
    border: 0;
    background: transparent;
    color: #856404;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
}

/* CLI 설치 가이드 모달 */
.cli-guide-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cli-guide-modal {
    background: #fff;
    border-radius: 12px;
    width: 520px;
    max-width: 95vw;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 8px 32px rgba(0,0,0,0.3);
}
.cli-guide-header {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    h5 { margin: 0; font-size: 16px; font-weight: 700; }
}
.cli-guide-icon { font-size: 22px; margin-right: 8px; }
.cli-guide-close {
    margin-left: auto;
    background: none; border: none;
    font-size: 24px; cursor: pointer; color: #999;
    &:hover { color: #333; }
}
.cli-guide-body { padding: 20px; }
.cli-guide-desc { color: #555; font-size: 14px; margin-bottom: 20px; line-height: 1.6; }
.cli-guide-step {
    display: flex;
    margin-bottom: 20px;
    h6 { margin: 0 0 4px; font-size: 15px; font-weight: 700; }
    p { margin: 0 0 8px; font-size: 13px; color: #666; line-height: 1.5; }
}
.step-number {
    width: 28px; height: 28px; min-width: 28px;
    border-radius: 50%;
    background: #4a90d9;
    color: #fff;
    display: flex; align-items: center; justify-content: center;
    font-weight: 700; font-size: 14px;
    margin-right: 12px; margin-top: 2px;
}
.step-content { flex: 1; min-width: 0; }
.step-hint { font-size: 12px !important; color: #999 !important; margin-top: 4px !important; }
.cli-guide-btn {
    display: inline-block;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    border: none;
    margin-bottom: 4px;
}
.cli-guide-btn-green { background: #28a745; color: #fff; &:hover { background: #218838; color: #fff; } }
.cli-guide-btn-blue { background: #4a90d9; color: #fff; &:hover { background: #357abd; } }
// 색이 지정되지 않은 버튼(보조 동작)도 버튼으로 보여야 한다.
.cli-guide-btn:not(.cli-guide-btn-green):not(.cli-guide-btn-blue) {
    background: #f1f3f5; color: #495057;
    &:hover { background: #e9ecef; }
}
.cli-guide-btn:disabled { opacity: 0.6; cursor: default; }
.cli-guide-cmd {
    display: flex;
    align-items: center;
    background: #1e1e1e;
    border-radius: 6px;
    padding: 10px 14px;
    cursor: pointer;
    margin-bottom: 4px;
    code { color: #4ec9b0; font-size: 13px; flex: 1; min-width: 0; overflow-wrap: anywhere; }
    &:hover { background: #2d2d2d; }
}
.copy-btn {
    color: #aaa;
    font-size: 12px;
    margin-left: 8px;
    white-space: nowrap;
}

/* CLI 상태 버튼 (헤더) */
.cli-status-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    position: relative;
}
.cli-update-dot {
    position: absolute;
    top: -4px; right: -4px;
    width: 16px; height: 16px;
    border-radius: 50%;
    background: #ff6b35;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    display: flex; align-items: center; justify-content: center;
}
.cli-spinner {
    width: 12px; height: 12px;
    border: 2px solid rgba(255, 193, 7, 0.3);
    border-top-color: #ffc107;
    border-radius: 50%;
    animation: cli-spin 0.8s linear infinite;

    /* 헤더 아이콘 어깨에 얹는 크기 */
    &--dot {
        position: absolute;
        top: -2px;
        right: -5px;
        width: 8px;
        height: 8px;
        border-width: 1.5px;
    }
}
@keyframes cli-spin {
    to { transform: rotate(360deg); }
}

/* 연결 상태 배너 */
.cli-banner {
    padding: 10px 14px;
    border-radius: 8px;
    font-size: 13px;
    margin-bottom: 12px;
}
.cli-banner-ok { background: #d4edda; color: #155724; }
.cli-banner-err { background: #f8d7da; color: #721c24; }
.cli-banner-update { background: #fff3cd; color: #856404; }

/* 섹션 타이틀 (신규 설치 / 업데이트) */
.cli-section-title {
    font-size: 14px;
    font-weight: 700;
    color: #333;
    margin: 0 0 12px;
    padding-bottom: 6px;
    border-bottom: 1px solid #eee;
}

/* OS 탭 */
.cli-os-tabs {
    display: flex;
    gap: 0;
    margin-bottom: 20px;
    border-bottom: 2px solid #eee;
    button {
        flex: 1;
        padding: 10px;
        border: none;
        background: none;
        font-size: 14px;
        font-weight: 600;
        color: #999;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        margin-bottom: -2px;
        &.active { color: #4a90d9; border-bottom-color: #4a90d9; }
        &:hover:not(.active) { color: #666; }
    }
}
</style>
